import * as Sentry from "@sentry/browser";
import {CurrentUserClass} from "shared/CurrentUser";

// where our bundles are served from - /static/multime3/dist/ on the site, the dev server's url under serve
const OWN_SCRIPT_PREFIX = new URL(__webpack_public_path__, window.location.origin).href;

// true when the exception has a stack but none of its frames ran through our bundles -
// scripts injected by browser extensions and in-app browsers (Instagram, Facebook...)
// throw on our pages and would otherwise land in Sentry as ours
function isThirdPartyOnly(event) {
    const values = (event.exception && event.exception.values) || [];
    const filenames = values
        .reduce((frames, value) => frames.concat((value.stacktrace && value.stacktrace.frames) || []), [])
        .map(frame => frame.filename)
        .filter(Boolean);
    return filenames.length > 0 && !filenames.some(filename => filename.startsWith(OWN_SCRIPT_PREFIX));
}

const CurrentUser = new CurrentUserClass();
if (SENTRY_DSN && CurrentUser.is_authenticated()) {
    Sentry.init({
        dsn: SENTRY_DSN,
        enabled: true,
        maxBreadcrumbs: 50,
        debug: false,
        ignoreErrors:[
            "Non-Error",
            'not allowed by the user agent',
            'failed because the user didn',
            'Redirected when going from',
        ],
        // matched against the frame that threw
        denyUrls: [
            /^webkit-masked-url:/i, // Safari hides extension script urls behind this
            /^(chrome|moz|safari|safari-web|ms-browser)-extension:/i,
            /^(chrome|resource):\/\//i,
        ],
        beforeSend(event) {
            return isThirdPartyOnly(event) ? null : event;
        },
    });
    if (CurrentUser.is_authenticated()) {
        Sentry.setUser({
            id: CurrentUser.id,
            username: CurrentUser.username,
        });
    }
}
export default Sentry;